import { DropdownsRepository } from '@/repositories/DropdownsRepository'
import { useQuery } from '@tanstack/react-query'

export const useDropdownData = <T>(entity: string) => {
  const dropdownsRepository = new DropdownsRepository<T>()
  return useQuery<T[]>({
    queryKey: [`${entity}-dropdown-data`],
    queryFn: () => dropdownsRepository.getAll(entity),
  })
}
